import { render } from "./Checkboard.vue?vue&type=template&id=e9a0ac98&scoped=true&ts=true"
import script from "./Checkboard.vue?vue&type=script&lang=ts"
export * from "./Checkboard.vue?vue&type=script&lang=ts"

import "./Checkboard.vue?vue&type=style&index=0&id=e9a0ac98&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9a0ac98"]])

export default __exports__